import Ajax from "Utils/ajax";
export const getMessageList = (data) => Ajax.post('hr/getMessageList',data);